import type { ComponentProps } from "react";
import type { VariantProps } from "tailwind-variants";
import { tv } from "tailwind-variants";

import { SvgSlot } from "@/shared/ui";

const styles = tv({
  slots: {
    primary: "",
    secondary: "fill-secondary-400",
  },
  variants: {
    theme: {
      dark: {
        primary: "fill-primary-50",
      },
      light: {
        primary: "fill-primary-950",
      },
    },
  },
});

export const Logo = ({
  theme = "light",
  ...props
}: ComponentProps<typeof SvgSlot> & VariantProps<typeof styles>) => {
  const { primary, secondary } = styles({ theme });

  return (
    <SvgSlot {...props}>
      <svg viewBox="0 0 454 70" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M80.9869 68.3863C73.5253 68.3863 68.7421 64.8467 68.7421 56.3328V0.465759H80.9869V55.0892C80.9869 57.7677 82.3262 58.9157 84.8135 58.9157H88.5443V68.3863H80.9869Z"
          className={primary()}
        />
        <path
          d="M120.272 69.5342C104.966 69.5342 95.2086 59.0113 95.2086 42.8443C95.2086 26.773 104.966 16.1544 119.985 16.1544C134.622 16.1544 144.283 26.2947 144.283 43.514V46.2882H107.932C108.41 55.2805 113.097 59.7766 120.368 59.7766C125.821 59.7766 129.551 57.1937 130.986 52.6976L143.518 53.4629C140.744 63.4118 132.039 69.5342 120.272 69.5342ZM107.932 38.0612H131.56C130.986 29.7385 126.49 25.8164 119.985 25.8164C113.384 25.8164 108.888 30.1212 107.932 38.0612Z"
          className={primary()}
        />
        <path
          d="M166.229 68.3863L147.575 17.3024H160.489L173.499 56.0458L186.414 17.3024H199.424L180.674 68.3863H166.229Z"
          className={primary()}
        />
        <path
          d="M227.799 69.5342C212.493 69.5342 202.736 59.0113 202.736 42.8443C202.736 26.773 212.493 16.1544 227.512 16.1544C242.149 16.1544 251.811 26.2947 251.811 43.514V46.2882H215.459C215.937 55.2805 220.625 59.7766 227.895 59.7766C233.348 59.7766 237.079 57.1937 238.513 52.6976L251.045 53.4629C248.271 63.4118 239.566 69.5342 227.799 69.5342ZM215.459 38.0612H239.087C238.513 29.7385 234.017 25.8164 227.512 25.8164C220.912 25.8164 216.415 30.1212 215.459 38.0612Z"
          className={primary()}
        />
        <path
          d="M274.181 68.3863C266.719 68.3863 261.936 64.8467 261.936 56.3328V0.465759H274.181V55.0892C274.181 57.7677 275.52 58.9157 278.007 58.9157H281.738V68.3863H274.181Z"
          className={primary()}
        />
        <path
          d="M312.222 69.5342C297.108 69.5342 289.168 62.3595 288.402 52.3149L300.934 51.741C301.795 57.0981 305.143 60.1593 312.222 60.1593C317.962 60.1593 321.406 58.4373 321.406 54.4195C321.406 50.9757 319.684 49.4451 310.213 47.8188C294.525 45.1402 289.646 40.9311 289.646 32.2258C289.646 22.7552 297.108 16.1544 311.266 16.1544C325.041 16.1544 332.12 23.5205 333.555 33.3737L321.119 33.9477C320.258 28.7819 316.814 25.5294 311.17 25.5294C305.335 25.5294 302.369 28.1123 302.369 31.8431C302.369 35.9566 305.048 37.5829 312.796 38.8265C328.868 41.3137 334.129 45.7142 334.129 54.2282C334.129 64.0814 325.232 69.5342 312.222 69.5342Z"
          className={primary()}
        />
        <path
          d="M346.811 68.3863V0.465759H372.544C386.798 0.465759 395.695 8.40576 395.695 21.0332C395.695 28.8776 390.242 34.8087 384.215 36.6263C390.242 37.6785 393.781 41.3137 394.451 48.3928L396.364 68.3863H388.042L386.32 49.2537C385.841 43.6096 382.589 41.0267 374.745 41.0267H355.038V68.3863H346.811ZM355.038 32.9911H373.597C381.824 32.9911 387.085 28.6863 387.085 20.8419C387.085 12.9976 381.919 8.50142 372.544 8.50142H355.038V32.9911Z"
          className={secondary()}
        />
        <path
          d="M406.78 68.3863L425.434 42.366L407.736 17.685H417.111L430.408 36.8176L443.323 17.685H452.889L435.383 42.5573L453.75 68.3863H444.375L430.408 47.9144L416.346 68.3863H406.78Z"
          className={secondary()}
        />
        <path
          d="M26.8013 0.466309H44.1687L18.1175 51.6468H0.750061L26.8013 0.466309Z"
          className={secondary()}
        />
        <path
          d="M40.8624 18.3534H58.2299L32.1787 69.5339H14.8112L40.8624 18.3534Z"
          className={secondary()}
        />
      </svg>
    </SvgSlot>
  );
};
